<template>
  <li class="nav-item">
    <router-link class="nav-link" :to="{ name: forwardPath }">
      <span :data-feather="feather"></span>
      <img :src="fullImagePath" :alt="alt" :width="width" :height="height" />
      {{ title }}
      <span class="sr-only" v-if="srOnly"></span>
    </router-link>
  </li>
</template>

<script>
export default {
  props: {
    forwardPath: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    feather: {
      type: String,
      default: '',
    },
    imagePath: {
      type: String,
      default: '',
    },
    alt: {
      type: String,
      default: '',
    },
    srOnly: {
      type: Boolean,
      default: false,
    },
    width: {
      type: Number,
      default: 18.62,
    },
    height: {
      type: Number,
      default: 17.64,
    },
  },
  computed: {
    fullImagePath() {
      return require('@/assets/images/' + this.imagePath);
    },
  },
};
</script>
